// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:1024px){#cz2.cz2 .cz2__design-side .cz2__menu__items{margin-top:25px}}", ""]);
// Exports
module.exports = exports;
